<template>
  <el-select
    ref="addressInput"
    v-model="selected"
    filterable
    :placeholder="placeholder"
    remote
    :remote-method="searchAddress"
    :loading="searching"
    default-first-option
    allow-create
    @change="onAddressSelection"
  >
    <el-option
      v-for="result in results"
      :key="result.udprn"
      :label="result.suggestion"
      :value="`UDPRN: ${result.udprn}`"
    ></el-option>
  </el-select>
</template>

<script>
import { Select, Option } from "element-ui";
import { get } from "dot-prop";
import { Client } from "@ideal-postcodes/core-axios";
import { debounce } from "lodash";

const IDEAL_POST_CODES_API_KEY = "ak_kfzf4xm8qzbGJ9cOtSgAw6inPWOWY";

const idealPostcodesClient = new Client({
  api_key: IDEAL_POST_CODES_API_KEY,
});

export default {
  name: "address-autocomplete-input",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      description: "Placeholder",
      required: false,
      default: "Type address here",
    },
  },
  data() {
    return {
      results: [],
      searching: false,
      selected: null,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.selected = val;
      }
    },
  },
  mounted() {
    if (this.value) {
      this.selected = this.value;
    }
  },
  computed: {
    header() {
      return {
        Authorization:
          'IDEALPOSTCODES api_key="' + IDEAL_POST_CODES_API_KEY + '"',
      };
    },
  },
  methods: {
    onAddressSelection(val) {
      if (!val.startsWith("UDPRN: ")) {
        this.$emit("input", val);
        return null;
      }

      const udprn = val.split("UDPRN: ")[1];

      this.loading = true;
      this.axios
        .request({
          method: "get",
          url: `https://api.ideal-postcodes.co.uk/v1/udprn/${udprn}`,
          withCredentials: false,
          headers: {
            Authorization:
              'IDEALPOSTCODES api_key="' + IDEAL_POST_CODES_API_KEY + '"',
          },
        })
        .then((response) => {
          this.loading = false;
          let addressSingleLine = "";

          if (response.data.result.line_1) {
            addressSingleLine += response.data.result.line_1;
            addressSingleLine += ", ";
          }

          if (response.data.result.line_2) {
            addressSingleLine += response.data.result.line_2;
            addressSingleLine += ", ";
          }

          if (response.data.result.line_3) {
            addressSingleLine += response.data.result.line_3;
            addressSingleLine += ", ";
          }

          if (response.data.result.county) {
            addressSingleLine += response.data.result.county;
            addressSingleLine += ", ";
          }

          if (response.data.result.postcode) {
            addressSingleLine += response.data.result.postcode;
          }

          // emit input
          this.$emit("input", addressSingleLine);
          this.selected = addressSingleLine;
        })
        .catch((err) => {
          this.loading = false;
          console.error("err: ", err);
        });
    },
    searchAddress: function (query) {
      this.searching = true;

      if (!query) {
        this.results = [];
        return;
      }

      const encodedQuery = encodeURIComponent(query);

      this.axios
        .request({
          method: "get",
          url: `https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?query=${encodedQuery}&api_key=${IDEAL_POST_CODES_API_KEY}`,
          withCredentials: false,
          headers: {},
        })
        .then((response) => {
          this.searching = false;
          this.results = response.data.result.hits;
        })
        .catch((err) => {
          this.searching = false;
          console.error("err: ", err);
        });
    },
  },
};
</script>
